import Close from "@/SvgIcons/Close";
import SearchIcon from "@/SvgIcons/SearchIcon";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./desktop-program.module.scss";
import programMenuData from "@/data/program-menu-data.json";
import Link from "next/link";
import { useSearchDebounce } from "@/helpers/useSearchDebounce";
import { useDebounce } from "@/helpers/debouncedFunctionReact";
import { usePathname } from "next/navigation";

const DProgramSearcher = ({ setIsMenuOpen }) => {
  const { MAIN_LIST } = programMenuData;
  const { Certifications } = programMenuData.PROGRAM_WISE;
  const newProgramList = [...MAIN_LIST, ...Certifications];  
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useSearchDebounce(searchValue, 300);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const pathName = usePathname();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null); // Step 1

  const onChangeHandler = (e) => {
    setIsMenuOpen(false);
    setSearchValue(e.target.value);
  };
  const onCloseHandler = () => {
    setSearchValue("");
    setIsSearchOpen(false);
  };
  const onClickHandler = () => {
    setIsSearchOpen(true);
  };

  const onSearchCloseHandler =(href)=>{
    if(pathName == href){
      setSearchValue("");
      setIsSearchOpen(false);
    }
  }

  useEffect(() => {
    if (isSearchOpen && inputRef.current) {
      inputRef.current.focus();
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isSearchOpen &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsSearchOpen(false);
        setSearchValue("");
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isSearchOpen]);

  const fireWebEngage = useDebounce((value, results) => {
    window.webengage.track("Search", {
      "Search Keyword": value,
      "Dropdown Value": results.map(({ Title }) => Title || "").join(", "),
    });
  }, 2000);

  const filteredProgramData = useMemo(() => {
    const query = debouncedSearchValue.toLowerCase().trim();
    if (!query) return [];
    let data = newProgramList.filter((program) =>
      program.Title.toLowerCase().includes(query)
    );
    fireWebEngage(debouncedSearchValue, data);
    return data;
  }, [debouncedSearchValue]);

  return isSearchOpen ? (
    <div ref={wrapperRef} className={styles.dProgramSearchWrapper}>
      <SearchIcon className={styles.dSearchIcon} color="#fff" />
      <input
        ref={inputRef}
        onChange={onChangeHandler}
        value={searchValue}
        placeholder="Search Programs"
        className={styles.dSearchInput}
        aria-label="Search Programs"
        type="text"
        autoComplete="off"
        spellCheck={false}
        name="Search Programs" 
      />

      <button
        className={styles.dSearchCloseButton}
        onClick={onCloseHandler}
        aria-label="Clear search"
      >
        <Close className={styles.dSearchClose} color="#fff" />
      </button>
      {debouncedSearchValue && (
        <div className={styles.dProgramResultMainContainer}>
          <div className={styles.dProgramSearchResults}>
            {filteredProgramData.length > 0 ? (
              filteredProgramData.map((program) => (
                <Link
                  className={styles.dSearchResultItem}
                  key={program.url}
                  title={program.Title}
                  href={`/${program.url}`}
                  aria-label={`Go to ${program.Title}`}
                  onClick={()=>{onSearchCloseHandler(`/${program.url}`)}}
                >
                  {program.Title}
                </Link>
              ))
            ) : (
              <div className={styles.dNoResults} role="alert">
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div
      className={styles.dProgramClosedSearchWrapper}
      onClick={onClickHandler}
    >
      <SearchIcon className={styles.dSearchIcon} color="#fff" />
    </div>
  );
};

export default DProgramSearcher;
